import React, { Component } from 'react'
import Constant, { getTypeTags } from '../../../Constant'
// import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'

class EditChaletBooking extends Component {
  state = {
    isLoading: false,
    type_tag: '',
    booking_status: '',
    is_paydo_store: false,
    selected_chalet_id: '',
    start_date: '',
    end_date: '',
    total_booking_amount: '',
    chalet_amount: '',
    slots: [],
  }

  componentDidMount = () => {
    this.setState(
      {
        type_tag: this.props.bookingDetails.type_tag,
        booking_status: this.props.bookingDetails.booking_status,
        is_paydo_store: this.props.bookingDetails?.additional_items?.find(
          (ele) => ele.store_item?.store?.is_paydo_store
        ),
        selected_chalet_id: this.props.bookingDetails?.chalet?.id,
        start_date: new Date(this.props.bookingDetails?.start_date),
        end_date: new Date(this.props.bookingDetails?.end_date),
        chalet_amount: this.props.bookingDetails?.chalet_amount,
        total_booking_amount:
          this.props.bookingDetails?.total_booking_amount - this.props.bookingDetails?.extra_payment,
      },
      () => {
        this.getChaletData({
          chalet_id: this.props.bookingDetails?.chalet?.id,
        })
      }
    )
  }

  tileDisabled = (date) => {
    const checkIfDateExists = this.state?.slots?.find((ele) => ele.date === moment(date.date).format('MM/DD/YYYY'))

    if (checkIfDateExists) {
      return false
    }
    return true
  }

  getChaletData = async (data) => {
    await axios
      .post(Constant?.getAPI() + `/chalet/check-available-slots`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            slots: res?.data?.data?.slots,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    })

    if (event.target.name === 'selected_chalet_id') {
      this.getChaletData({
        chalet_id: event.target.value,
      })
    }
  }

  handleStartDate = (event) => {
    this.setState({
      start_date: event,
    })
  }

  handleEndDate = (event) => {
    this.setState({
      end_date: event,
    })
  }

  render() {
    return (
      <div style={{ width: 800, paddingRight: 40 }}>
        <div className="header">
          <b>Edit Booking</b>
        </div>
        <div className="body m-t-20">
          <div className="row">
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Booking Status</label>
                <div className="col-9">
                  <select
                    name="booking_status"
                    className="form-control"
                    value={this.state.booking_status}
                    onChange={this.handleChange}
                  >
                    <option value={''}>N/A</option>
                    <option value="Pending">Pending</option>
                    <option value="Confirmed">Confirmed</option>
                    <option value="Successful">Successful</option>
                    <option value="Cancelled">Cancelled</option>
                    <option value="Postponed">Postponed</option>
                  </select>
                  {this.state.is_paydo_store && (
                    <div style={{ color: 'red' }}>
                      To cancel store items order, Need to contact with <b>Paydo Team</b>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Booking Type tag</label>
                <div className="col-9">
                  <select
                    name="type_tag"
                    className="form-control"
                    value={this.state.type_tag}
                    onChange={this.handleChange}
                  >
                    <option value={''}>N/A</option>
                    {getTypeTags().map((itm) => (
                      <option
                        key={itm}
                        value={itm}
                      >
                        {itm}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Select chalet</label>
                <div className="col-9">
                  <select
                    name="selected_chalet_id"
                    className="form-control"
                    value={this.state.selected_chalet_id}
                    onChange={this.handleChange}
                  >
                    <option
                      value={''}
                      key={''}
                    >
                      Select chalet
                    </option>
                    {this.props.chaletList.map((itm) => (
                      <option
                        value={itm.id}
                        key={itm.id}
                      >
                        {itm.chalet_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {/* <div className="col-6">
              <div className="col-12">
                <div className="form-group row">
                  <label className="col-12 col-form-label">Select start Date</label>
                </div>
              </div>
              <div className="col-12">
                <Calendar
                  value={this.state.start_date}
                  tileDisabled={(date) => this.tileDisabled(date)}
                  onChange={this.handleStartDate}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="col-12">
                <div className="form-group row">
                  <label className="col-12 col-form-label">Select end Date</label>
                </div>
              </div>
              <div className="col-12">
                <Calendar
                  value={this.state.end_date}
                  tileDisabled={(date) => this.tileDisabled(date)}
                  onChange={this.handleEndDate}
                />
                {moment(this.state.start_date).format('YYYY-MM-DD') >=
                  moment(this.state.end_date).format('YYYY-MM-DD') && (
                  <div style={{ color: 'red' }}>Start date should be less than end date</div>
                )}
              </div>
            </div> */}
            <div className="col-12 mt-3">
              <div className="form-group row">
                <label className="col-3 col-form-label">Chalet Amount</label>
                <div className="col-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter chalet amount"
                    value={this.state.chalet_amount}
                    name="chalet_amount"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group row">
                <label className="col-3 col-form-label">Total Booking Amount</label>
                <div className="col-9">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter total amount"
                    value={this.state.total_booking_amount}
                    name="total_booking_amount"
                    onChange={this.handleChange}
                  />
                  <div style={{ color: 'red' }}>After changing this it may effect booking details on mobile app</div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="text-right col-6 offset-6">
              <button
                onClick={() => this.props.editBookingCruise(this.state)}
                className="btn hor-grd btn-grd-inverse offset-1"
                disabled={
                  (this.state.type_tag == this.props.bookingDetails.type_tag &&
                    this.state.booking_status == this.props.bookingDetails.booking_status &&
                    this.state.total_booking_amount == this.props.bookingDetails.total_booking_amount &&
                    this.state.chalet_amount == this.props.bookingDetails.chalet_amount &&
                    this.state.start_date == this.props.bookingDetails.start_date &&
                    this.state.end_date == this.props.bookingDetails.end_date &&
                    this.state.selected_chalet_id == this.props.bookingDetails.chalet.id) ||
                  moment(this.state.start_date).format('YYYY-MM-DD') >= moment(this.state.end_date).format('YYYY-MM-DD')
                }
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default EditChaletBooking
